import type {
  ConfigurationTestResult,
  ConfigurationTestResultId,
  ConfigurationTestResultResourceType,
} from "@repo/app-types/entities/configurationTestResult";
import { api } from "../redux.js";

const configurationTestResultApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * One saved test result as stored, for the editor opened from its chat
     * row (see `useDeepLinkedTestResult`). Only a row of the named resource
     * type is found. Rows are history, so nothing invalidates them.
     */
    getConfigurationTestResult: builder.query<
      ConfigurationTestResult,
      {
        resourceType: ConfigurationTestResultResourceType;
        testResultId: ConfigurationTestResultId;
      }
    >({
      query: ({ resourceType, testResultId }) => ({
        method: "GET",
        url: `/copilot/test-results/${encodeURIComponent(testResultId)}`,
        params: { resource_type: resourceType },
      }),
      transformResponse: (response: {
        data: { test_result: ConfigurationTestResult };
      }) => response.data.test_result,
    }),
  }),
});

export const { useGetConfigurationTestResultQuery } =
  configurationTestResultApi;
